import React, { Suspense, lazy } from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import useImagePreloader from '@swf/sports/hooks/useImagePreloader';

import maintenanceBackgroundImage from './Maintenance/assets/maintenance-pss.jpg';
import migrationBackgroundImage from './Migration/assets/migration-pss.jpg';
import styles from './SportsMaintenance.scss';

const Maintenance = lazy(() => import('./Maintenance/Maintenance'));
const Migration = lazy(() => import('./Migration/Migration'));

export const SportsMaintenance = () => {
  const isMigrationBanner = useFeature(FeatureFlag.ISPMigrationBanner);
  const { imagesPreloaded } = useImagePreloader([
    maintenanceBackgroundImage,
    migrationBackgroundImage
  ]);

  const loader = (
    <div className={styles.container}>
      <LoadingIndicator loading variant="light" className={styles.loader} />;
    </div>
  );

  return imagesPreloaded ? (
    <Suspense fallback={loader}>{isMigrationBanner ? <Migration /> : <Maintenance />}</Suspense>
  ) : (
    loader
  );
};

export default SportsMaintenance;
